var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "master_svg0_173_25074"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 22,
    height: 22,
    rx: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#master_svg0_173_25074)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.268263300000001,17.628839C8.7715356,15.797575,5.5,11.520793,5.5,9.124991399999999C5.5,6.0186877,7.9626383999999995,3.5,10.9999824,3.5C14.0373936,3.5,16.5,6.0187044,16.5,9.124991399999999C16.5,11.5207796,13.2284536,15.797569,11.7317133,17.628837C11.3647742,18.108522999999998,10.635201,18.108525999999998,10.2682629,17.628839M10.9999824,7.0010238000000005C9.8530765,7.0010238000000005,8.9231622,7.9520864,8.9231622,9.125042C8.9231622,10.2980623,9.8530765,11.2490926,10.9999824,11.2490926C12.1469226,11.2490926,13.076820399999999,10.2980623,13.076820399999999,9.125042C13.076820399999999,7.9520864,12.1469231,7.0010238000000005,10.9999824,7.0010238000000005Z",
    fill: "#C6CAD1",
    fillOpacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.8fd53e1f8e4295576b68bed9a3ab716a.svg";
export { ForwardRef as ReactComponent };